<div class="uil-dls-font-body-01" *ngFor="let overviewItem of overviewList">
    <div class=" row uil-container-section-title uil-font-medium-weight">
        <span>{{overviewItem.overviewLabel}}</span>
    </div>
    <div class="uil-dls-font-body-01">
        <p class="overview-description uil-dls-font-body-01">
            {{overviewItem.overviewDescription}}
        </p>
    </div>
</div>
